import React, { useEffect, useState } from "react";
import { Theme } from "../../constant/Theme";
import { ThemeContext } from "./ThemeContext";
import { LocalStorageKeys } from "../../types/LocalStorageKeys";

export interface ThemeProviderProps {
  children: React.ReactNode;
}

const GetThemeFromMemory = () => {
  const theme = localStorage.getItem(LocalStorageKeys.THEME);
  if (!theme) return Theme.DARK;
  return theme === Theme.LIGHT ? Theme.LIGHT : Theme.DARK;
};

const GetSatelliteModeFromMemory = () => {
  const satelliteMode = localStorage.getItem(LocalStorageKeys.SATELLITE_MODE);
  if (satelliteMode === null) return false;
  return satelliteMode === "true";
};

export const ThemeProvider = ({ children }: ThemeProviderProps) => {
  const [theme, setTheme] = useState<Theme>(GetThemeFromMemory());
  const [satelliteMode, setSatelliteMode] = useState<boolean>(
    GetSatelliteModeFromMemory(),
  );

  useEffect(() => {
    localStorage.setItem(LocalStorageKeys.THEME, theme);
  }, [theme]);

  useEffect(() => {
    localStorage.setItem(
      LocalStorageKeys.SATELLITE_MODE,
      String(satelliteMode),
    );
  }, [satelliteMode]);

  const toggleTheme = () => {
    setTheme((prevTheme) =>
      prevTheme === Theme.LIGHT ? Theme.DARK : Theme.LIGHT,
    );
  };

  const toggleSatelliteMode = () => {
    setSatelliteMode((prevSatelliteMode) => !prevSatelliteMode);
  };

  return (
    <ThemeContext.Provider
      value={{
        theme,
        toggleTheme,
        satelliteMode,
        toggleSatelliteMode,
      }}
    >
      {children}
    </ThemeContext.Provider>
  );
};
